import {useParams, useNavigate} from "react-router-dom";
import {Tabs} from "antd";
import className from "classnames/bind";
import {Button, FontAwesomeIcon, Loading, PageHeader, ProjectToolNav} from "~/components";
import {useGetTechnicalReportQuery} from "~/reduxs/api/technicalApiSlice";
import TechSummary from "../components/TechSummary";
import TechInternalLinks from "../components/TechInternalLinks";
import TechBrokenLinks from "../components/TechBrokenLinks";
import TechRedirects from "../components/TechRedirects";
import TechRobots from "../components/TechRobots";
import TechSitemap from "../components/TechSitemap";
import style from "../style/Technical.module.scss";

const cn = className.bind(style);

/**
 * Trang tool "Kỹ thuật SEO" của một Project: đọc lần crawl mới nhất và trình bày theo tab
 * (Tổng quan / Liên kết nội bộ / Liên kết hỏng / Chuyển hướng / Robots.txt). Nếu project
 * chưa có lần crawl nào hoàn tất → gợi ý chạy Site Crawler trước.
 */
function TechnicalHome() {

	const {id} = useParams();
	const navigate = useNavigate();

	const {data, isLoading, isError} = useGetTechnicalReportQuery(id);

	if (isLoading) return <Loading />;

	const project = data?.project;

	const header = (
		<>
			<ProjectToolNav projectId={id} active="technical" />
			<PageHeader
				icon="fa-light fa-screwdriver-wrench"
				title="Kỹ thuật SEO"
				subtitle={project?.root_url}
			/>
		</>
	);

	if (isError || !data) {
		return <div className="container">{header}<div className={cn('empty')}>Không tải được dữ liệu.</div></div>;
	}

	if (!data.crawl) {
		return (
			<div className="container">
				{header}
				<div className={cn('empty')}>
					<FontAwesomeIcon icon="fa-light fa-spider" />
					<p>Dự án chưa có lần crawl nào hoàn tất. Hãy chạy Site Crawler để có dữ liệu kỹ thuật.</p>
					<Button primary onClick={() => navigate(`/projects/${id}/crawler`)}
						leftIcon={<FontAwesomeIcon icon="fa-light fa-play" />}>
						Mở Site Crawler
					</Button>
				</div>
			</div>
		);
	}

	const {summary, internal, broken, redirects, robots, crawl} = data;

	const items = [
		{key: 'summary', label: 'Tổng quan', children: <TechSummary summary={summary} />},
		{key: 'internal', label: `Liên kết nội bộ`, children: <TechInternalLinks internal={internal} />},
		{
			key: 'broken',
			label: <span>Liên kết hỏng {summary.broken_internal + summary.broken_external > 0 && <b className={cn('badge')}>{summary.broken_internal + summary.broken_external}</b>}</span>,
			children: <TechBrokenLinks broken={broken} />,
		},
		{key: 'redirects', label: 'Chuyển hướng', children: <TechRedirects projectId={id} redirects={redirects} />},
		{key: 'sitemap', label: 'Sitemap', children: <TechSitemap projectId={id} />},
		{key: 'robots', label: 'Robots.txt', children: <TechRobots robots={robots} />},
	];

	return (
		<div className="container">
			{header}
			<div className={cn('crawlMeta')}>
				Dữ liệu từ lần crawl <strong>#{crawl.id}</strong> — {crawl.pages_crawled} trang — {crawl.finished_at || crawl.created}
			</div>
			<Tabs defaultActiveKey="summary" items={items} />
		</div>
	);
}

export default TechnicalHome;
